module.exports = __webpack_public_path__ + "img/verified.4abc71b4.svg";